import { CREATE_INTEREST, REMOVE_INTEREST } from "./actions";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../../../utils/localStorage";

export const interests = (state=loadFromLocalStorage(CREATE_INTEREST, []), action) =>{
    const {type, payload} = action;

    switch(type){
        case CREATE_INTEREST:{
            const {interest} = payload;
            const newInterest = {
                interest,
            };
            const updatedState = state.concat(newInterest);
            saveToLocalStorage(CREATE_INTEREST, updatedState);
            return updatedState;
        }
        case REMOVE_INTEREST: {
            const {interest} = payload;
            const updatedState = state.filter(obj => obj.interest !== interest);
            saveToLocalStorage(REMOVE_INTEREST, updatedState);
            return updatedState;
        }
        default: 
            return state;
    }
}